import React, { useEffect, useState, useRef } from 'react';
import './Home.css';
// Import video with webpack to ensure it works
import homeVideo from '../components/videos/home-video.mp4';
// Import a default background image
// Note: You'll need to add a real image to this path
// import bgImage from '../assets/images/tattoo-bg.jpg';
import { useLanguage } from '../context/LanguageContext';

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const heroContentRef = useRef(null);
  const { t } = useLanguage();
  
  // Default dark background color as fallback
  const bgFallback = '#121212';

  // Check if device is mobile and update window height
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setWindowHeight(window.innerHeight);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handle parallax effect on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle visibility for animations
  useEffect(() => {
    const heroContent = heroContentRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // Reset visibility when element is out of view
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (heroContent) {
      observer.observe(heroContent);
    }

    return () => {
      if (heroContent) {
        observer.unobserve(heroContent);
      }
    };
  }, []);

  const scrollToNextSection = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const parallaxStyle = {
    transform: `translateY(${scrollPosition * 0.4}px)`,
    backgroundColor: bgFallback,
  };

  return (
    <div className="home" id="home">
      <section className="hero" style={isMobile ? {height: `${windowHeight}px`} : {}}>
        <div className="hero-bg-container">
          <div 
            className="hero-bg-image" 
            style={parallaxStyle}
          ></div>
        </div>
        <div className="hero-video-container">
          <video autoPlay muted loop playsInline className="hero-video">
            <source src={homeVideo} type="video/mp4" />
            {t('home.browserUnsupported')}
          </video>
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-content" ref={heroContentRef}>
          <h1 className={`salon-name ${isVisible ? 'animate-title' : ''}`}>
            {t('home.welcomeTitle')}
          </h1>
          <p className={`${isVisible ? 'animate-text' : ''}`}>
            {t('home.welcomeText')}
          </p>
        </div>
        <div className="scroll-down-arrow" onClick={scrollToNextSection}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="1.5" />
            <path d="M7 10L12 15L17 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </section>
    </div>
  );
};

export default Home; 